export { selectProductVariant } from 'utils/selectProductVariant'
import { pricify } from 'utils/pricify'

const KEYS = ['devices', 'cartridges', 'accessories', 'skins']

export const setTotalPrice = collection => {
  let totalPrice = 0

  KEYS.forEach(key => {
    if (collection[key]) {
      collection[key].forEach(product => {
        product.variants.forEach(variant => {
          if (variant.quantity > 0) {
            totalPrice += variant.quantity * parseFloat(variant.price)
          }
        })
      })
    }
  })

  return pricify({ amount: totalPrice })
}

export const setCartLineItems = (collection, engraving) => {
  let lineItems = []

  KEYS.forEach(key => {
    if (collection[key]) {
      collection[key].forEach(product => {
        product.variants.forEach(variant => {
          if (variant.quantity > 0) {
            let lineItem = {
              variantId: variant.id,
              quantity: variant.quantity,
              product: product,
              variant: variant
            }

            if (key === 'devices' && engraving.proceeded && product.tags.includes('engravable')) {
              lineItem = {
                ...lineItem,
                customAttributes: [
                  {
                    key: 'engraving',
                    value: JSON.stringify(engraving)
                  }
                ]
              }
            }

            lineItems.push(lineItem)
          }
        })
      })
    }
  })

  return lineItems
}

export const handleSkinsQuantity = (collection, quantity, product) => {
  const skinIndex = collection.skins.findIndex(a => a.id === product.id)
  collection.skins[skinIndex].variants[0].quantity = quantity
  return collection
}

export const setPhotoSrcs = (selectedVariant, currentView, background = false) => {
  let photoSrcs

  const variantTitle = selectedVariant.title.toLowerCase().replace(/\s/g, '')

  if (background) {
    photoSrcs = `${process.env.BASE_PATH}/images/products/epod/background/${variantTitle}.jpg`
  } else {
    if (currentView.item === 'front') {
      photoSrcs = [selectedVariant.image]
    } else if (currentView.item === 'back') {
      photoSrcs = [{ originalSrc: `${process.env.BASE_PATH}/images/engraving/devices/${variantTitle}-back.png` }]
    } else if (currentView.item === 'box') {
      photoSrcs = [{ originalSrc: `${process.env.BASE_PATH}/images/engraving/box/box.png` }]
    } else {
      photoSrcs = [
        selectedVariant.image,
        { originalSrc: `${process.env.BASE_PATH}/images/engraving/devices/${variantTitle}-back.png` },
        { originalSrc: `${process.env.BASE_PATH}/images/engraving/box/box.png` }
      ]
    }
  }

  return photoSrcs
}
